"use client";

import { FONT_MONO, TEXT_MUTE } from "./palette";

type Props = {
  children: string;
};

export function PedagogyPanelSectionTitle({ children }: Props) {
  return (
    <div
      style={{
        fontSize: 10,
        color: TEXT_MUTE,
        letterSpacing: "0.15em",
        fontWeight: 600,
        marginBottom: 10,
        fontFamily: FONT_MONO,
        textTransform: "uppercase",
      }}
    >
      {children}
    </div>
  );
}
